import { Panel } from 'react-bootstrap';
import { IListItem, IPhoneNumberForEdit } from '@nkr/models/index';
import PhoneNumberList from './list';

interface IProps {
    contactId: number,
    phoneNumbers: IPhoneNumberForEdit[],
    phoneTypes: IListItem[],
    mobileProviders: IListItem[],
    showMobileProvider: boolean,
    onChange: (list: IPhoneNumberForEdit[]) => void
}

const PhoneNumberPanel = (props: IProps) => {
    return (
        <Panel>
            <Panel.Heading>Phone Numbers</Panel.Heading>
            <Panel.Body>
                <PhoneNumberList
                    contactId={props.contactId}
                    phoneNumbers={props.phoneNumbers}
                    phoneTypes={props.phoneTypes}
                    mobileProviders={props.mobileProviders}
                    showMobileProvider={props.showMobileProvider}
                    viewOnly={false}
                    onChange={props.onChange}
                />
            </Panel.Body>
        </Panel>
    );
}

export default PhoneNumberPanel;